import { writable } from 'svelte/store';
export let elementsById = writable({});
export let selectedElement = writable(null);
export let addedFilters = writable([]);
export let elementStore = writable([]);
